import React, { useEffect, useRef } from 'react';

const MicLevelMeter = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        let audioContext;
        let analyser;
        let source;
        let animationFrameId;

        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
            analyser = audioContext.createAnalyser();
            analyser.fftSize = 512;

            source = audioContext.createMediaStreamSource(stream);
            source.connect(analyser);

            const dataArray = new Uint8Array(analyser.fftSize);
            const canvas = canvasRef.current;
            const canvasCtx = canvas.getContext('2d');

            const draw = () => {
                animationFrameId = requestAnimationFrame(draw);
                analyser.getByteTimeDomainData(dataArray);

                canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
                canvasCtx.fillStyle = '#ffffff';
                canvasCtx.fillRect(0, 0, canvas.width, canvas.height);

                const average = dataArray.reduce((sum, val) => sum + Math.abs(val - 128), 0) / dataArray.length;
                const barHeight = (average * 3.2 / 128) * canvas.height;

                canvasCtx.fillStyle = '#0B89A4';
                canvasCtx.fillRect(0, canvas.height - barHeight, canvas.width, barHeight);
            };

            draw();
        }).catch(err => {
            console.error('Mic access denied or unavailable:', err);
        });

        return () => {
            cancelAnimationFrame(animationFrameId);
            if (source) source.disconnect();
            if (analyser) analyser.disconnect();
            if (audioContext && audioContext.state !== 'closed') audioContext.close();
        };
    }, []);

    return (
        <div className='flex-cont'>
            <canvas className='mic-lvl'
                ref={canvasRef}
                width="15" />
        </div>
    );
};

export default MicLevelMeter;
